/// <amd-module name="SuiteCommerce.GridOrder.MatrixItemOption.View"/>
define("SuiteCommerce.GridOrder.MatrixItemOption.View", ["require", "exports", "underscore", "SuiteCommerce.GridOrder.Configuration", "grid_order_cell_matrix_item_option.tpl"], function (require, exports, _, GridOrder_Configuration_1, matrixItemOptionTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MatrixItemOptionViewPrototype = /** @class */ (function () {
        function MatrixItemOptionViewPrototype() {
        }
        Object.defineProperty(MatrixItemOptionViewPrototype.prototype, "template", {
            get: function () {
                return matrixItemOptionTemplate;
            },
            enumerable: true,
            configurable: true
        });
        MatrixItemOptionViewPrototype.prototype.isColor = function () {
            var _this = this;
            var tableDisplayOptions = GridOrder_Configuration_1.GridOrderConfiguration.tableDisplayOptions;
            var displayOption = _.find(tableDisplayOptions, function (displayOption) {
                return displayOption.itemFieldID === _this.model.customItemFieldId;
            });
            return !!displayOption;
        };
        MatrixItemOptionViewPrototype.prototype.getColorValue = function () {
            var _this = this;
            var tableDisplayOptions = GridOrder_Configuration_1.GridOrderConfiguration.tableDisplayOptions;
            var colorPalette = GridOrder_Configuration_1.GridOrderConfiguration.colorPalette;
            var displayOption = _.find(tableDisplayOptions, function (displayOption) {
                return displayOption.itemFieldID === _this.model.customItemFieldId;
            });
            if (displayOption) {
                var color = _.find(colorPalette, function (color) {
                    return color.paletteId === displayOption.paletteId && color.colorName === _this.model.label;
                });
                if (color)
                    return color.colorValue;
            }
            return '';
        };
        MatrixItemOptionViewPrototype.prototype.getContext = function () {
                var colorPalette = GridOrder_Configuration_1.GridOrderConfiguration.colorPalette;
                
                let labelImage = colorPalette.find(o => o.colorName ===  this.model.label);
                
                var image ;
                if(labelImage != undefined){
                   if(labelImage.imgsrc){
                        image = labelImage
                   }    
                }  

                var isNew=false
                const newStyles = ['Fishbowl Blue', 'Flower Power', 'Lavender Scales', 'Musical Mermaid', 'Shark Camo', 'Surf Rider',
                    'Pink Aloha','Starfish Jelly','Skater Bird','Surfing Starfish','Crocodile', 
                'Pink/Purple','Teal/Pink','Ice Blue/Lime Green','Yellow/Blue','Pink/Orange/Aqua','Aqua/Yellow/Pink','Red/Orange/Green','Turquoise/Teal','Blue/Green/Purple',
                'Pink/Purple','Orange/Blue/Red','Pink/Orange/Aqua','Aqua/Yellow/Pink','Turquoise/Teal','Dune Mirror','Glacier Mirror','Orchid Mirror','Sage Mirror','Sage Tint',
                'Glacier Clear','Dune Mirror','Plum Mirror','Coral Mirror','Teal Mirror','Dusk Mirror','Forest Mirror']
                    if (_.contains(newStyles, this.model.label)) {
                        isNew=true
                    }
                
                var isNewSizing=false
                const newSizing=  ['Navy/Red', 'Black/Gray']
                if (_.contains(newSizing, this.model.label)) {
                        isNewSizing=true
                    }
                    
                if(image && image.colorName){
                    switch(image.colorName){
                        case "Whale":
                                 image.colorName+=" (Level 1)"
                            break;
                        case "Pufferfish":
                                image.colorName+=" (Level 2)"
                                break; 
                        case "Starfish":
                                image.colorName+=" (Level 3)"
                                break; 
                        case "Turtle":
                                image.colorName+=" (Level 4)"
                                break; 
                        case "Shark":
                                image.colorName+=" (Level 5)"
                                break; 
                        default :
                            image.colorName=image.colorName
                        break
                    }
                }
                    
            return {
                label: this.model.label,
                showAsColor: !!(this.isColor() && this.getColorValue()),
                colorValue: this.getColorValue(),
                isWhiteColor: this.model.label === 'white',
                image:image,
                isNew:isNew,
                isNewSizing:isNewSizing,
                
            };
        };
        return MatrixItemOptionViewPrototype;
    }());
    exports.MatrixItemOptionViewPrototype = MatrixItemOptionViewPrototype;
});
